/**
 * ChannelLink Component
 * Renders a #channel reference inside message content as a clickable pill.
 * Clicking navigates to the channel; channels the user can't access show a toast instead.
 */

import React from 'react';
import { toast } from 'sonner';
import { useChannels } from '@/hooks/useChannels';
import { useAppStore } from '@/store/app.store';

interface ChannelLinkProps {
  channelId: string;
  /** Display label as stored in the message, e.g. "#счетоводство" */
  label: string;
}

export const ChannelLink: React.FC<ChannelLinkProps> = ({ channelId, label }) => {
  const { data: channels } = useChannels();
  const channel = channels?.find((c) => c.id === channelId);

  const handleClick = () => {
    if (channel) {
      useAppStore.getState().setActiveChannel(channel.id);
    } else if (channels) {
      toast.error('Нямате достъп до този канал');
    }
    // While the channel list is still loading, do nothing
  };

  return (
    <button
      type="button"
      onClick={handleClick}
      className={`inline-flex items-center px-1 py-0.5 rounded font-medium text-[13px] align-baseline transition-colors ${
        channel || !channels
          ? 'bg-blue-500/10 text-blue-600 dark:text-blue-400 hover:bg-blue-500/20 hover:underline cursor-pointer'
          : 'bg-gray-500/10 text-gray-500 dark:text-gray-400 cursor-pointer'
      }`}
    >
      {label}
    </button>
  );
};
